import axios, { AxiosError } from 'axios';
import { useAuthStore } from '../auth/store';

export const api = axios.create({ baseURL: '/api/v1', withCredentials: false });

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing: Promise<void> | null = null;

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError) => {
    const original = error.config as (typeof error.config & { _retry?: boolean }) | undefined;
    if (error.response?.status === 401 && original && !original._retry) {
      const auth = useAuthStore.getState();
      if (!auth.refreshToken) {
        auth.clear();
        return Promise.reject(error);
      }
      original._retry = true;
      refreshing ??= (async () => {
        try {
          const res = await axios.post('/api/v1/auth/refresh', { refreshToken: auth.refreshToken });
          useAuthStore.getState().setTokens(res.data.accessToken, res.data.refreshToken);
        } catch {
          useAuthStore.getState().clear();
        } finally {
          refreshing = null;
        }
      })();
      await refreshing;
      const fresh = useAuthStore.getState().accessToken;
      if (fresh && original.headers) {
        original.headers.Authorization = `Bearer ${fresh}`;
        return api.request(original);
      }
    }
    return Promise.reject(error);
  }
);
